<template>
  <div class="cloud-wrap">
    <div class="clearfix">
      <div
        class="noCycle-main clearfix"
        v-loading.body="loading">
        <div
          v-for="item in cloudData"
          :key="item.id"
          v-show="cloudData.length > 0"
        >
          <el-checkbox-group
            v-model="checkList"
            class="clearfix"
          >
            <!--遮罩层 选择按钮后 S-->
            <div
              class="cycle-mask"
              v-show="additionalSub.isCyCLeChooseMask">
              <el-checkbox
                :disabled="item.file_list.length === 0"
                @change="setList(item.yun_id, item.id)"
                :label="`${item.yun_id}_${item.id}`"
                :key="item.id">{{ item.file_name }}</el-checkbox>
            </div>
            <!--遮罩层 选择按钮后 E-->
            <div class="hover-cloud">
              <!--默认无 显示层 S-->
              <div
                class="cycle-cont hover-mask2"
                :class="item.file_list && item.file_list.length >0 ? 'cycle-confirmed' : ''"
              > <!--  加class cycle-confirmed 有材料已确认增加蓝色背景 无材料则不增加class-->
                <template v-if="item.astatus === 1">
                  <div class="confirmed">已确认</div>
                </template>
                <div class="cycle-ico"/>
                <div>{{ item.file_name }}</div>
              </div>
              <!--默认无 显示层 E-->


              <!--鼠标放上 出现 S-->
              <div class="cycle-hover hover-mask clearfix">
                <div>
                  <el-button
                    type="primary"
                    size="small"
                    @click="setConfirmed({upload_position: uploadPosition.upload_position, upload_type_str: item.file_name, offer_school_id: uploadPosition.offer_school_id, upload_type: item.id}, item.astatus === 1 ? 2 : 1)">{{ item.astatus === 1 ? '驳回' : '确认' }}</el-button><!--确认 驳回-->
                </div>
                <div v-if="parameterData.country_id === 30 || parameterData.country_id === 31 || parameterData.country_id === 83 || parameterData.country_id === -485" >
                  <el-button
                    type="danger"
                    size="small"
                    @click="setDelete(item.id)">删除</el-button>
                </div>
                <div
                  v-else
                  v-show="item.default !== 1">
                  <el-button
                    type="danger"
                    size="small"
                    @click="setDelete(item.id)">删除</el-button>
                </div>
                <div v-if="parameterData.country_id === 83 || parameterData.country_id === 485 || parameterData.country_id === -485">
                  <el-button
                    type="primary"
                    size="small"
                    :disabled="item.file_list.length === 0"
                    @click="setPreview({upload_position: uploadPosition.upload_position, upload_type_str: item.file_name, offer_school_id: uploadPosition.offer_school_id, upload_type: item.id}, item.id,item.file_list[0])">预览</el-button>
                </div>
                <div v-if="parameterData.country_id === 30 || parameterData.country_id === 31 || parameterData.country_id === 485|| parameterData.country_id === -485">
                  <jm-upload-file
                    :url="uploadUrl"
                    :upload-data="uploadData"
                    :show-file-list="false"
                    :upload-additional="{upload_position: uploadPosition.upload_position, upload_type_str: item.file_name, offer_school_id: uploadPosition.offer_school_id, upload_type: item.id, country_id: parameterData.country_id}"
                    @upload-get-info="uploadGetInfo"
                  >
                    <template slot="uploadFile">
                      <el-button
                        type="primary"
                        size="small">上传</el-button>
                        <!-- <div class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                    </template>
                  </jm-upload-file>
                </div>
                <div v-if="parameterData.country_id === 30 || parameterData.country_id === 31 || parameterData.country_id === 83">
                  <el-button
                    type="primary"
                    size="small"
                    @click="downloadFile(item)"
                    :disabled="item.file_list && item.file_list.length === 0"
                  >下载</el-button>
                </div>
              </div>
            <!--鼠标放上 出现 E-->
            </div>
          </el-checkbox-group>
        </div>
        <div
          class="cloudSet"
          @click="setDataCloud"><i>+</i>
        </div>
      </div>
    </div>

    <!--设置材料显示层 start-->
    <el-dialog
      :visible.sync="setDataVisible"
      class="dialog-disk"
      title="设置材料"
      @close="dialogClose">
      <jm-newTableCheckbox
        ref="tableCheckbox"
        title="设置材料"
        subtitle="报名材料"
        @dialog-disk-visible="dialogDiskVisible"
        :upload-data="uploadData"
        :upload-position="uploadPosition"
        :cloud-disk-data.sync="setCloudData"
      />
    </el-dialog>
    <!--设置材料显示层 end-->
    <!--走马灯 预览展示 start-->
    <template v-for="item in cloudData">
      <img
        v-img="{ group: `group_${item.yun_id}_${item.id}` }"
        v-for="(itemFile, index) in item.file_list"
        :key="`group_${item.yun_id}_${item.id}_${index}`"
        :src="itemFile | imgHome"
        v-if="groups[`group_${item.yun_id}_${item.id}`]"
        v-show="false"
        ref="vueimg"
      >
    </template>
    <!--走马灯 预览展示 end-->
    <div
      class="rotate-area left-rotate"
      @click="rotateClick(-90)"
    />
    <div
      class="rotate-area right-rotate"
      @click="rotateClick(90)"
    />
    <div
      class="rotate-area del-rotate"
      @click="delPic"
      v-if="parameterData.country_id !== 83"
    />
    <div
      class="rotate-area save-rotate"
      @click="saveRotate"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import { getBinaryContent } from 'jszip-utils';
import JSZip from 'jszip';
import NProgress from 'nprogress';
import VueImg from '@/plugins/v-img';
import newTableCheckbox from '@/components/tool/newTableCheckbox';
import { jmUploadFile } from '@/components/tool';
import { messageBox } from '@/utils/messagebox';


Vue.use(VueImg);
const msgObj = {
  message: '此操作将删除材料, 是否继续?',
};
const countryId = {
  country_id: 485,
};

let tempCurrent = {};

export default {
  props: {
    /*
      * 上传Url
      * */
    uploadUrl: {
      type: String,
    },
    /*
      * 上传请求参数
      * */
    uploadData: {
      type: Object,
      default() {
        return {};
      },
    },
    /*
      * 上传位置
      * */
    uploadPosition: {
      type: Object,
      default() {
        return {};
      },
    },
    /*
      * 控制遮罩显示
      * */
    additionalSub: {
      type: Object,
      default() {
        return {};
      },
    },
    /*
      * 全选按钮数据
      * */
    allCheckData: {
      type: Array,
    }
  },
  data() {
    return {
      loading: false, // Loading
      setCloudData: [],
      checkList: [],
      cloudData: [], // 初始化数据
      setDataVisible: false,
      picFilesUrl: [], // 预览图片
      setuploadData: {}, // 临时跑拼接数据
      previewData: {}, // 临时上传参数数据
      currentGroup: '',
      parameterData: '',
      groups: {},
      thisData: null
    };
  },
  methods: {
    /*
      * 初始化数据
      * */
    getDiskInfo() {
      this.loading = true;
      let data1 = {};
      let data2 = countryId;
      Object.assign(data1, data2, this.uploadData, this.uploadPosition);
      this.parameterData = data1;
      return this.$http._post({
        url: '/index/apply_file/index',
        data: data1,
      }).then((res) => {
        this.loading = false;
        this.cloudData = res.data;
        this.$emit('component-cloud-data', this.cloudData);
      });
    },
    /*
      * 设置材料
      * */
    dialogClose() {
      this.$refs.tableCheckbox.closeMeterial();
    },
    /*
      * 加号设置
      * */
    setDataCloud() {
      this.setDataVisible = true;
      let data1 = {};
      let data2 = countryId;
      Object.assign(data1, data2, this.uploadData, this.uploadPosition);
      this.$http._post({
        url: '/index/apply_file/getlist',
        data: data1
      }).then((res) => {
        if (typeof (res.data) === 'object') {
          this.setCloudData = Object.values(res.data);
        } else {
          this.setCloudData = res.data;
        }
      });
    },
    /*
       * 确认 and 驳回
       * */
    setConfirmed (collection, status) {
      let data1 = {};
      let data2 = countryId;
      Object.assign(data1, data2, this.uploadData, { ...collection }, { status });
      this.$http._post({
        url: '/index/apply_file/setStatus',
        data: data1,
      }).then(() => {
        this.getDiskInfo();
      });
    },
    /*
       * 单个云盘删除
       * */
    setDelete (id) {
      messageBox.msgBox(msgObj).then(() => {
        this.deleteDisk(id);
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    /*
       * 单个云盘删除
       * */
    deleteDisk(id) {
      let data1 = {};
      let data2 = countryId;
      Object.assign(
        data1, data2, this.uploadPosition,
        this.uploadData, { add: 0, upload_type: [id] }
      );
      this.$http._post({
        url: 'index/apply_file/setUploadType/',
        data: data1,
      }).then(() => {
        this.$message.success('删除成功');
        this.getDiskInfo();
      });
    },
    /*
       * 预览云盘材料
       * */
    setPreview (data, id, url) {
      tempCurrent = data;
      this.cloudData.forEach((item) => {
        if (item.file_list.length > 0) {
          if (item.id === id) {
            this.currentGroup = `group_${item.yun_id}_${item.id}`;
            this.$set(this.groups, this.currentGroup, true);
            this.$nextTick(() => {
              this.$vImg.open(this.currentGroup);
              if (this.checkImg(url) === 1) {
                this.$el.querySelectorAll('.rotate-area').forEach((item) => {
                  item.style.display = 'block';
                });
              }
            });
          }
        }
      });
    },
    /*
       * 旋转后保存
       * */
    saveRotate() {
      let data1 = {};
      let data2 = countryId;
      let currentImg = window.vueImg.sImages[window.vueImg.currentImageIndex];
      let oldurl = currentImg.orginsrc || (currentImg.orginsrc = currentImg.getAttribute('src'));
      oldurl = oldurl.substring(0, oldurl.indexOf('?'));
      let imgurl = document.querySelector('.endCanvas').src;
      Object.assign(data2, { country_id: this.parameterData.country_id });
      Object.assign(
        data1, data2, tempCurrent,
        this.uploadData, { file_url: oldurl, file_data: imgurl }
      );
      this.$http._post({
        url: '/index/apply_file/saveFile',
        data: data1,
      }).then(() => {
        currentImg.src = imgurl;
        this.getDiskInfo();
        this.$message.success('保存成功');
      });
    },
    /*
      * 删除预览图片
      * */
    delPic() {
      let imgurl = document.querySelector('.endCanvas').src;
      imgurl = imgurl.substring(imgurl.indexOf('/Uploads'));
      let data1 = {};
      let data2 = countryId;
      Object.assign(data2, { country_id: this.parameterData.country_id });
      Object.assign(data1, data2, tempCurrent, this.uploadData, { file_url: imgurl });
      messageBox.msgBox(msgObj).then(() => {
        this.$http._post({
          url: 'index/apply_file/deleteFile',
          data: data1,
        }).then(() => {
          this.getDiskInfo().then(() => {
            let data = this.$el.querySelectorAll(`[data-vue-img-group=${this.currentGroup}`);
            if (data.length === 0) {
              window.vueImg.close();
              return true;
            }
            data[0].click();
          });
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    /*
       * 云盘材料图片旋转
       * */
    rotateClick(angle) {
      window.vueImg.rotate(angle);
    },
    /*
       * 子层传值 关闭dialog对话框
       * */
    dialogDiskVisible(cb) {
      this.setDataVisible = cb.isdialog;
      this.getDiskInfo();
    },
    /*
      * 上传成功 请求刷新页面
      * */
    uploadGetInfo(cb) {
      if (cb === true) {
        this.getDiskInfo();
      }
    },
    /*
      *  验证图片类型
      * */
    checkImg(url) {
      let isImg = ['bmp', 'jpg', 'jpeg', 'png', 'gif'];
      let strTemp = url.split('.');
      let strCheck = strTemp[strTemp.length - 1];
      let result = 0;
      if (this.isInArray(isImg, strCheck)) {
        result = 1;
      } else {
        result = 2;
      }
      return result;
    },
    /*
      * 验证图片类型
      * */
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },
    /*
       * 单选后判断是否为全选
       * */
    setList(position, id) {
      this.checkList.concat(`${position}_${id}`);
      this.$emit('check-list-data', this.checkList);
    },
    /*
      *  全选重置 数组
      * */
    refAllCheckList() {
      this.checkList = this.allCheckData;
    },
    /**
       * Description: 单个下载
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    onlyDown(yun, id) {
      this.$http._post({
        url: '/index/apply_file/downloadFile',
        data: {
          data_list: { [yun]: [id] },
          country_id: this.parameterData.country_id,
          crm_id: this.$route.params.id
        }
      }).then((response) => {
        if (response.data) {
          window.location.href = response.data;
        }
      });
    },
    getFileName(url, folder) {
      const parts = url.split('/');
      return `${folder}/${parts[parts.length - 1]}`;
    },
    downloadFile(item) {
      if (!item.file_list.length || item.file_list.length === 0) {
        this.$message.error('没有文件');
        return false;
      }
      const msg = this.$message({
        message: '下载中...',
        duration: 0,
        showClose: false,
      });
      NProgress.start();
      let currentProgress = 0;
      Promise.all(item.file_list.map((url) => {
        return getBinaryContent(
          Vue.filter('imgHome')(url, true),
          {
            progress: (p) => {
              if (p.percent === 100) {
                currentProgress += 100;
                NProgress.set(currentProgress / 100 / item.file_list.length);
              }
            }
          }
        );
      })).then((data) => {
        const zip = new JSZip();
        zip.folder(item.file_name);
        data.forEach((buffer, index) => {
          zip.file(this.getFileName(item.file_list[index], item.file_name), buffer, { binary: true });
        });
        zip.generateAsync({ type: 'blob' }).then((blob) => {
          this.$http.saveFile(blob, item.file_name);
          this.$message.success('下载成功！');
          msg.close();
        });
      }).catch(() => {
        this.$message.error('下载失败！');
        msg.close();
        NProgress.done(true);
      });
    }
  },
  mounted() {
    this.thisData = Date.parse(new Date());
    if (this.uploadData.crm_id) {
      this.getDiskInfo();
    }
  },
  computed: {
  },
  components: {
    'jm-newTableCheckbox': newTableCheckbox, // 设置材料
    jmUploadFile,
  },
  watch: {
    'uploadData.crm_id'() {
      this.getDiskInfo();
    },
    allCheckData() {
      this.checkList = this.allCheckData;
    }
  }
};
</script>
<style scoped>
  .hover-cloud{
    display: flex;
    width: 100%;
    height: 100%;
  }
  .hover-cloud:hover .hover-mask{
    width: 100%;
    display: flex;
  }
  .hover-cloud .hover-mask{
    position: relative;
    z-index: 0;
    width: 100%;
    margin: 6px;
    display: none;
  }
  .hover-cloud:hover .hover-mask2{
    width: 100%;
    display: none;
  }
  .hover-cloud .hover-mask2{
    width: 100%;
    display: block;
  }
  .cloud-wrap{
    background: #fff;
    min-height: 120px;
  }
  .noCycle-main > .el-checkbox-group {
    font-size: 100%;
  }
  .noCycle-main > div{
    display: flex;
    position: relative;
    width: 160px;
    height: 112px;
    margin: 10px;
    float: left;
    border: #b8c4ce dashed 1px;
    cursor: pointer;
  }
  .cycle-cont{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    font-size: small;
  }
  .cycle-ico{
    background: url("../../../src/assets/images/cycle-ico.png") no-repeat;
    display: block;
    width: 45px;
    height:45px;
    margin: 10px auto;
  }
  .cycle-confirmed .cycle-ico{
    background: url("../../../src/assets/images/cycle-ico1.png") no-repeat;
  }
  .cycle-confirmed{
    background: #3368fa;
    color: #fff;
  }
  .confirmed{
    position: absolute;
    right: 0px;
    top: 5px;
    padding: 2px 8px;
    background: #ffcd38;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    color: #424141;
    font-size: 12px;
  }
  .cycle-hover{
    width: 100%;
    display: flex;
    background: #f2f2f2;
    border: solid #e7e7e7 1px;
    align-items: center;
    flex-wrap:wrap;
  }
  .cycle-hover > div{
    width: 50%;
    text-align: center;
  }
  .cloudSet{
    display: flex;
    position: relative;
    width: 160px;
    height: 112px;
    margin: 10px;
    padding: 6px;
    float: left;
    border: #b8c4ce dashed 1px;
    cursor: pointer;
  }
  .cloudSet i {
    margin: 6px auto;
    text-align: center;
    font-size: 100px;
    line-height:60px;
    color: #3368fa;
  }
  .left-rotate{
    position: fixed;
    bottom:20px;
    left:45%;
    width: 50px;
    height:50px;
    z-index: 1003;
    cursor: pointer;
    background: #fff url(../../../src/assets/images/icon-rotate-l.png) no-repeat center;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    display: none;
  }
  .right-rotate{
    position: fixed;
    bottom:20px;
    left:49%;
    width: 50px;
    height:50px;
    z-index: 1003;
    cursor: pointer;
    background: #fff url(../../../src/assets/images/icon-rotate-r.png) no-repeat center;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    display: none;
  }
  .save-rotate{
    position: fixed;
    bottom:20px;
    left:53%;
    width: 50px;
    height:50px;
    line-height:50px;
    background: #fff;
    z-index: 1003;
    color:#333;
    text-align: center;
    cursor: pointer;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    font-size:15px;
    display: none;
  }
  .del-rotate{
    position: fixed;
    bottom:20px;
    left:57%;
    width: 50px;
    height:50px;
    line-height:50px;
    background: #fff;
    z-index: 1003;
    color:#333;
    text-align: center;
    cursor: pointer;
    opacity:0.8;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    border-radius: 5px;
    font-size:15px;
    display: none;
  }
  .left-rotate:hover,.right-rotate:hover,.save-rotate:hover.del-rotate:hover{
    opacity:1;
  }
  .save-rotate:after{
    content:"保存";
  }
  .del-rotate:after{
    content: "删除";
  }
  .content-v-img{
    text-align: center;
  }
  .content-v-img canvas {
    pointer-events: none;
  }
  .cycle-mask{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .cycle-mask .el-checkbox{
    width: 100%;
    height: 100%;
    margin: 4px;
  }
</style>
